import { TRootState } from '../reducers';

export const selectRequiresSupport = (state: TRootState) => state.supportRequest.requiresSupport; 